import { Article } from './article'
import { Book } from './book'
import { Report } from './report'

export default {
    article: Article,
    book: Book,
    report: Report
}